import Component from 'gia/Component'
import eventbus from 'gia/eventbus';
import stage from '../components/stage'
import renderer from '../components/render'
import _each from 'lodash.foreach'
import gsap from 'gsap'


class Newsletter extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.i = 0


    this.ref = {

    }

  }

  mount() {

    $('.button--newsletter').on('click', ()=>{
      $('.button--newsletter').addClass('is-hidden')
      $('.newsletter').addClass('is-visible')
    })



    $('#newsletter__form').on('submit', (e)=>{
        e.preventDefault()
        const form = $('#newsletter__form')
        const url = form.attr('action')
        const email = form.find('#mce-EMAIL').val()
        const name = form.find('#mce-MMERGE5').val()
        const error = $('.newsletter .newsletter__message')
        error.html(``)
        form.addClass('sending')
        $('#mc-embedded-subscribe').attr('disabled', true)

        this.mailchimp(email, url, name).done(
          (data) => {
            if (data.result != "success") {
                form.addClass('error')
                form.removeClass('sending')
                error.html(`<p>${data.msg}</p>`)
                $('#mc-embedded-subscribe').attr('disabled', false)

            } else {
                form.addClass('done')
                form.removeClass('sending error')
                form.find('#mce-EMAIL').val('')
                form.find('#mce-MMERGE5').val('')
                error.html(`<p>${data.msg}</p>`)
                $('#mc-embedded-subscribe').attr('disabled', false)
            }
        }).fail(
          (err) => {
              form.addClass('error')
              form.removeClass('sending')
              $('#mc-embedded-subscribe').attr('disabled', false)
          }
        )
    })




  }


  mailchimp(email, url, name) {

    var data = {
      'EMAIL': email,
      'MMERGE5': name,
      utf8: '✓'
    };

    var promise = $.ajax({
        url: url ,
        method: 'post',
        data: data,
        cache       : false,
        dataType    : 'jsonp',
        jsonp: 'c',
        contentType: "application/json; charset=utf-8"
    })

    return promise;
  }






  unmount() {

    //this.delayedCall.kill()
    // stage.removeListener("stage:resize", this.resizeQue);
    // stage.removeListener("stage:scroll", this.renderQue);

  }


}

module.exports = Newsletter
